import { SiteHeader } from '../../shared/components/SiteHeader';
import { SiteFooter } from '../../shared/components/SiteFooter';
import { MapSection } from '../../shared/components/MapSection';
import styles from './TopPage.module.css';
import aboutImage from '../../../assets/top/about.png';
import ceoImage from '../../../assets/top/ceo.png';

type ServiceItem = {
  readonly title: string;
  readonly body: readonly string[];
};

const SERVICES: readonly ServiceItem[] = [
  {
    title: 'IT事業',
    body: [
      'AIを活用した資産形成支援サービス。',
      '楽天証券を活用した自動売買システムにより、データベースによる運用支援を提供しています。',
    ],
  },
  {
    title: '資産運用事業',
    body: [
      'お客様一人ひとりに合わせた資産形成サポート。',
      'IFAとして、投資・保険・ライフプランなど、中長期視点での支援を行います。',
    ],
  },
];

type WhyItem = {
  readonly number: string;
  readonly heading?: string;
  readonly body: string;
};

const WHY_ITEMS: readonly WhyItem[] = [
  { number: '01', heading: 'Technology', body: 'AIとデータを活用した運用支援。' },
  { number: '02', heading: 'Technology', body: 'AIとデータを活用した運用支援。' },
  {
    number: '03',
    body: '強固なパートナーシップに基づく多角的な価値創造',
  },
];

export const TopPage = (): JSX.Element => {
  return (
    <div className={styles.page}>
      <SiteHeader variant="overlay" />

      <section className={styles.hero}>
        <p className={styles.heroEyebrow}>INVEST BEYOND BORDERS.</p>
        <h1 className={styles.heroTitle}>
          テクノロジーと金融知見で
          <br />
          長期的な資産形成を支援
        </h1>
        <p className={styles.heroLead}>
          AIを活用した運用支援と、IFAによるサポートを通じて、
          <br />
          一人ひとりに寄り添った資産形成を支援します
        </p>
        <div className={styles.scroll}>
          <span className={styles.scrollLine} aria-hidden />
          <span className={styles.scrollText}>SCROLL</span>
        </div>
      </section>

      <section className={styles.about}>
        <img
          className={styles.aboutImage}
          src={aboutImage}
          alt="C.J INVESTMENT CO.,LTD オフィスサイン"
        />
        <div className={styles.aboutText}>
          <p>
            CJインベストメント株式会社は資産運用のアドバイスを提供する
            IFA（独立系ファイナンシャルアドバイザー）です。
          </p>
          <p>
            短期的な利益ではなく、長期的な価値を見据える。
            市場環境が変化し続ける時代だからこそ、短期的視点に左右されない、合理的な資産形成支援を大切にしています。
          </p>
        </div>
      </section>

      <section id="service" className={styles.service}>
        <div className={styles.serviceInner}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>SERVICE</p>
            <h2 className={styles.sectionTitle}>サービス紹介</h2>
          </div>
          <div className={styles.serviceGrid}>
            {SERVICES.map((service) => (
              <div key={service.title} className={styles.serviceItem}>
                <h3 className={styles.serviceItemTitle}>{service.title}</h3>
                <div className={styles.serviceItemBody}>
                  {service.body.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.serviceActions}>
            <a href="#service" className={styles.button}>
              詳しく見る
            </a>
          </div>
        </div>
      </section>

      <section className={styles.why}>
        <div className={styles.whyInner}>
          <div className={styles.sectionHead}>
            <p className={styles.eyebrow}>WHY CJ INVESTMENT</p>
            <h2 className={styles.sectionTitle}>選ばれる理由</h2>
          </div>
          <div className={styles.whyGrid}>
            {WHY_ITEMS.map((item) => (
              <div key={item.number} className={styles.whyItem}>
                <p>
                  <span className={styles.whyNumber}>{item.number}</span>
                  {item.heading}
                </p>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="message" className={styles.message}>
        <img
          className={styles.messageImage}
          src={ceoImage}
          alt="代表取締役 李 松"
        />
        <div className={styles.messageBody}>
          <p className={styles.eyebrow}>MESSAGE</p>
          <h2 className={styles.messageTitle}>
            AIと金融の組み合わせで、更なる資産形成を促進します
          </h2>
          <p className={styles.messageText}>
            テクノロジーの進化により、投資や資産形成、そしてビジネスのあり方は今、かつてないスピードで変革の時を迎えています。 私たちは「金融×IT」「保険×IT」というクロスドメインを最大の強みとし、 最先端のAI技術やFinTechを駆使して、社会に新しい価値を創造するプロフェッショナル集団です。 <br /><br />これから投資を始めたい個人のお客様にも、AIや先進技術でビジネスの飛躍を目指す法人のお客様にも、 確かな技術力と専門知識を融合させた「最適なアンサー」をご提供いたします。 テクノロジーと金融の力で未来の可能性を切り拓くベストパートナーとして、私たちにぜひご期待ください。
          </p>
          <div className={styles.messageSign}>
            <p className={styles.messageSignRole}>代表取締役</p>
            <p className={styles.messageSignName}>李 松</p>
          </div>
          <a href="#message" className={styles.button}>
            会社概要を見る
          </a>
        </div>
      </section>

      <MapSection />

      <SiteFooter />
    </div>
  );
};
